import { INotification, NotificationType } from "types/notification-type";
import './Notification.scss';
import { faCheck, faExclamation, faInfo, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Translate from "../Translate";
import { Component } from "react";

type NotificationItemPropsType = {
    notification: INotification
    onClick: (i: INotification) => void
}

interface NotificationItemPropsTypeState {
    interval?: any,
    time: number,
    stopTime: boolean
}

const TimerInterval = 10;
const NotificationTime = 2000;

class NotificationItem extends Component<NotificationItemPropsType, NotificationItemPropsTypeState> {
    constructor(props: NotificationItemPropsType) {
        super(props);

        this.state = {
            time: NotificationTime,
            stopTime: false
        };
    }

    remove = () => {
        this.killTimer();
        this.props.onClick(this.props.notification);
    };

    componentDidMount() {
        this.updateTime();
    }

    componentDidUpdate() {
        if (this.state.time < 1) this.remove();
    }

    componentWillUnmount() {
        this.killTimer();
    }

    private killTimer = () => {
        clearInterval(this.state.interval);
        this.setState({
            interval: undefined
        });
    };

    updateTime = () => {
        const t = setInterval(this.timer, TimerInterval);
        this.setState({
            interval: t
        });
    }

    timer = () => {
        if(this.state.stopTime) return;
        this.setState({
            time: this.state.time - TimerInterval
        });
    }

    // #region render

    getIcon(type: NotificationType) {
        switch (type) {
            case 'success': return faCheck;
            case 'error': return faTimes;
            case 'info': return faInfo;
            case 'warning': return faExclamation;
        }
    }

    renderDescription(description?: string) {
        if (description) return <span>{description}</span>;
    }

    getWidth = () => {
        const t = (this.state.time / NotificationTime) * 100;
        return t + '%';
    }

    render() {
        return (
            <>
                <div 
                    onClick={this.remove} 
                    className={`app-notification-item ${this.props.notification.type}`} 
                    onMouseDown={() => this.setState({stopTime: true})} 
                    onMouseUp={() => this.setState({stopTime: false})}
                    onTouchStart={() => this.setState({stopTime: true})}
                    onTouchEnd={() => this.setState({stopTime: false})}
                >
                    <div className='app-notification-icon'>
                        <FontAwesomeIcon icon={this.getIcon(this.props.notification.type)} />
                    </div>
                    <div className='app-notification-text'>
                        <p className='app-notification-message'>
                            <Translate i18nKey={this.props.notification.message} />
                        </p>
                        <p className='app-notification-description'>
                            {this.renderDescription(this.props.notification.description)}
                        </p>
                    </div>
                </div>
                <div className='app-notification-footer' style={{ width: this.getWidth() }}>
                </div>
            </>
        );
    }
    // #endregion
}

export const NOTIFICATION_EVENT_TRIGGER_ELEMENT_NAME = 'app-notifications-container';
export const NOTIFICATION_EVENT_TRIGGER_NAME = 'addNotification';

type NotificationStateType = {
    notifications: INotification[]
}

class Notification extends Component<any, NotificationStateType> {

    constructor(props: any) {
        super(props);
        this.state = {
            notifications: []
        };
    }

    remove = (n: INotification) => {
        this.setState({
            notifications: this.state.notifications.filter(no => {
                return no.id !== n.id;
            })
        });
    }

    componentDidMount(): void {
        document.getElementById(NOTIFICATION_EVENT_TRIGGER_ELEMENT_NAME)?.addEventListener(NOTIFICATION_EVENT_TRIGGER_NAME, this.addNotification);
    }

    componentWillUnmount(): void {
        // document.getElementById(NOTIFICATION_EVENT_TRIGGER_ELEMENT_NAME)!.removeEventListener(this.addNotification);
    }

    private addNotification = (event: any) => {
        if(!event.detail) return;
        this.setState({
            notifications: [...this.state.notifications, event.detail]
        })
    }

    // #region render

    renderNotifications = () => {
        return (
            <ul className='app-notifications' id="app-notifications">
                {this.state.notifications.map(n => {
                    return (
                        <li key={n.id}>
                            <NotificationItem onClick={this.remove} notification={n} />
                        </li>
                    );
                })}
            </ul>
        );
    }

    render() {
        return <div className='app-notifications-container' id="app-notifications-container">
            {this.state.notifications?.length ? this.renderNotifications() : <></>}
        </div>;
    }
    // #endregion
}

export default Notification;
